<template>
	<div class="template number">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<input class="input_value" :change="changeVal()" v-model="dataVal.Value" type="text" :disabled="dataVal.Property.Title[0].Text=='流程条件'" />
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			changeVal() {
				var value = this.dataVal.Value;
				if(this.dataVal.Property.Title[0].Text == '流程条件'){
					return;
				}
				if(value == null||value == -1){
					return;
				}
				this.dataVal.Value = ((value+"").match(/^\d{0,9}/g)[0]) || null;
			}
		}
	}
</script>

<style scoped>
	@import '../../assets/css/common.css';
</style>
